import { render, staticRenderFns } from "./TwoColText.vue?vue&type=template&id=3506a1b5"
import script from "./TwoColText.vue?vue&type=script&lang=js"
export * from "./TwoColText.vue?vue&type=script&lang=js"
import style0 from "./TwoColText.vue?vue&type=style&index=0&id=3506a1b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports